import { useEffect, useState } from 'react';
import { type InsightsClient } from 'search-insights';

import { useFragmentContext } from '@jsmdg/react-fragment-scripts/fragment';
import { type FragmentContext } from '../../shared/types';

export const useInsightsClient = (): InsightsClient | undefined => {
    const { algoliaConfig } = useFragmentContext<FragmentContext>();
    const [insightsClient, setInsightsClient] = useState<InsightsClient | undefined>(undefined);

    useEffect(() => {
        setInsightsClient(() => {
            if (!algoliaConfig.userToken) return undefined;

            // eslint-disable-next-line @typescript-eslint/no-var-requires,global-require
            const newInsightsClient = require('search-insights') as InsightsClient;
            newInsightsClient('init', {
                appId: algoliaConfig.appId,
                apiKey: algoliaConfig.searchKey,
            });
            newInsightsClient('setUserToken', algoliaConfig.userToken);

            return newInsightsClient;
        });
    }, [algoliaConfig.appId, algoliaConfig.searchKey, algoliaConfig.userToken]);

    return insightsClient;
};
